import { ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { ColorTypes } from "@omegagrid/core";
import { msg, getLocale } from "@omegagrid/localize";
import { NodeSource, TreeAdapter, TreeOptions, TreeSource } from "@omegagrid/tree";
import rp, { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import { Message as WikiMessage, Page } from "@reporting/rp-types/wiki";

const PAGE_SIZE = 500;

class WikiPageTreeAdapter extends TreeAdapter {

	private items: NodeSource[];

	constructor(private a: number) { super() }

	async getTree(): Promise<TreeSource> {
		if (this.items) return this.items;

		const pages = await rp.ms('wiki').get<Page[]>('pages', {
			where: { lang: getLocale() },
			fields: ['id_wiki_page', 'name'],
			order: ['name'],
			accounting: this.a,
		});

		this.items = pages.map(page => ({
			k: page.id_wiki_page.toString(),
			v: page.name,
		}));

		return this.items;
	}

	getOptions(): Partial<TreeOptions> {
		return {
			search: true,
			selectMode: 'single',
			allowEmpty: false
		};
	}

}

export class MessagesGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor(private a: number) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			data: 'controls',
			t: 'a',
			e: false,
			w: 5 + 20 * 1,
			content: [{
				action: 'delete',
				title: msg('Delete'),
				icon: 'trash',
				color: ColorTypes.Red
			}],
			filter: false,
			sorting: false,
		}, {
			data: 'id_wiki_page',
			header: msg('Page'),
			t: 's',
			adapter: new WikiPageTreeAdapter(this.a),
			e: true,
			w: 400
		}, {
			data: 'date_publish',
			header: msg('Publish'),
			t: 'dt',
			e: true,
			w: 180,
		}, {
			data: 'who_created',
			header: msg('Created by'),
			t: 't',
			e: false,
			w: 180,
		}, {
			data: 'date_created',
			header: msg('Created'),
			t: 'dt',
			e: false,
			w: 145,
		}, {
			data: 'idz',
			t: 'n',
			hidden: true,
			e: false,
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]> {
		const messages = await rp.ms('wiki').get<WikiMessage[]>('messages', this.createRequestParams(filters, {
			count: PAGE_SIZE,
			accounting: this.a,
		}));
		return messages.map(data => ({ data: {
			...data,
			id_wiki_page: { v: data.id_wiki_page, dv: data.name, e: false },
			date_publish: { v: data.date_publish, dv: !data.date_publish ? msg('Immediately') : undefined, e: false, t: data.date_publish ? 'dt' : 't' },
		}}));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: PAGE_SIZE,
			refreshAfterSave: true,
			saveMode: 'edited_rows',
			rowMenu: {
				deleteRows: true,
			},
		});
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({_state: row.state, _index: row.index}, row.data));
		await rp.ms('wiki').post('messages', data, { accounting: this.a });
	}

}
